import { render, staticRenderFns } from "./MiniCart.vue?vue&type=template&id=872beb2e&scoped=true"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"
import style0 from "./MiniCart.vue?vue&type=style&index=0&id=872beb2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872beb2e",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fmini-cart%2FMiniCart.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports